import {defineStore} from 'pinia';
import {ref} from 'vue';
import {NavBarDisplayMode} from '../aside-menu.types';
import {useNavigationTabs} from '@/logged/features/aside-menu/composables';

export const useExpandedTabs = defineStore(
    'expanded-tabs',
    () => {
        /** Store ids of expanded tabs, and keep it in storage  */
        const expandedTabs = ref<string[]>([]);
        const hydrated = ref(false);
        const {allNavigationRoutes} = useNavigationTabs();

        function toggleExpandTab(id: string) {
            if (allNavigationRoutes.value.find((tab) => !!tab.children && tab.id === id)) {
                if (expandedTabs.value.includes(id)) {
                    expandedTabs.value = expandedTabs.value.filter((tabId) => tabId !== id);
                } else {
                    expandedTabs.value = [id];
                    // Replace with this line you want to have the bahviour to not close all other tabs
                    // expandedTabs.value.push(id);
                }
            }
        }

        function expandTab(id: string) {
            if (allNavigationRoutes.value.find((tab) => !!tab.children && tab.id === id)) {
                expandedTabs.value = [id];
            }
        }

        function closeAll() {
            expandedTabs.value = [];
        }

        return {
            expandedTabs,
            expandTab,
            closeAll,
            toggleExpandTab,
            hydrated,
        };
    },
    {
        persist: {
            storage: window.sessionStorage,
            paths: ['expandedTabs'],
            afterRestore(context) {
                // To avoid false behaviour when there is saved open tabs but "reduced" mode saved
                const store = context.store as ReturnType<typeof useExpandedTabs>;
                if (window.navbarDisplayMode === NavBarDisplayMode.REDUCED) {
                    // Decomment this if you want to not cache previously opend tabs in reduced mode
                    // store.expandedTabs = [];
                }

                store.hydrated = true;
            },
        },
    },
);
